/* ApexFPV — FR→EN search synonym interceptor
   Vanilla ES6 IIFE, defer-safe
   ─────────────────────────────────────────── */
(function () {
  'use strict';

  /* Ordered longest-first so multi-word entries match before single-word subsets */
  var SYNONYMS = [
    ['drone longue portee',   'long range lr'],
    ['drone longue distance', 'long range lr'],
    ['drone de course',       'racing drone'],
    ['drone freestyle',       'freestyle drone'],
    ['drone pliable',         'folding foldable foldape4'],
    ['drone pliant',          'folding foldable foldape4'],
    ['drone plie',            'folding foldable foldape4'],
    ['drone debutant',        'beginner starter drone'],
    ['drone novice',          'beginner starter drone'],
    ['moins de 250g',         'sub250 lightweight'],
    ['moins de 250',          'sub250 lightweight'],
    ['sous 250g',             'sub250 lightweight'],
    ['sous 250',              'sub250 lightweight'],
    ['temps de vol',          'flight time'],
    ['duree de vol',          'flight time'],
    ['longue portee',         'long range lr'],
    ['longue distance',       'long range lr'],
    ['controleur de vol',     'flight controller fc'],
    ['faible latence',        'low latency'],
    ['analogique video',      'analog vtx'],
    ['baby ape',              'babyape ii'],
    ['bon marche',            'affordable budget'],
    ['pas cher',              'affordable budget'],
    ['quadrirotor',           'quadcopter'],
    ['quadcoptere',           'quadcopter'],
    ['foldape',               'foldape4 long range'],
    ['babyape',               'babyape ii'],
    ['speedybee',             'speedybee master 5 v2'],
    ['master 5',              'speedybee master 5 v2'],
    ['o3 air unit',           'dji o3 hd'],
    ['acrobatie',             'acrobatic freestyle'],
    ['acrobatique',           'acrobatic freestyle'],
    ['acro',                  'acrobatic freestyle'],
    ['debutant',              'beginner'],
    ['debutante',             'beginner'],
    ['novice',                'beginner starter'],
    ['intermediaire',         'intermediate'],
    ['professionnel',         'professional'],
    ['professionnelle',       'professional'],
    ['portee',                'range'],
    ['autonomie',             'flight time'],
    ['vitesse',               'speed'],
    ['rapide',                'fast'],
    ['leger',                 'lightweight'],
    ['legere',                'lightweight'],
    ['poids',                 'weight'],
    ['reglementation',        'regulation compliant'],
    ['conforme',              'compliant'],
    ['homologue',             'certified compliant'],
    ['numerique',             'digital'],
    ['analogique',            'analog'],
    ['moteur',                'motor'],
    ['moteurs',               'motor'],
    ['helice',                'propeller props'],
    ['helices',               'propeller props'],
    ['recepteur',             'receiver'],
    ['batterie',              'battery'],
    ['batteries',             'battery'],
    ['chargeur',              'charger'],
    ['transmetteur',          'transmitter'],
    ['telecommande',          'remote controller'],
    ['elrs',                  'elrs long range'],
    ['expresslrs',            'elrs long range'],
    ['voyage',                'travel portable'],
    ['transportable',         'portable travel'],
    ['accessoire',            'accessory'],
    ['accessoires',           'accessory accessories'],
    ['pieces',                'parts'],
    ['reparation',            'repair parts'],
    ['abordable',             'affordable budget'],
    ['meilleur',              'best top'],
    ['nouveau',               'new latest'],
    ['nouveaute',             'new latest'],
    ['drones',                'drone fpv'],
    ['drone',                 'drone fpv'],
    ['course',                'racing'],
    ['latence',               'latency'],
    ['camera',                'camera'],
    ['caméra',                'camera'],
  ];

  function norm(str) {
    return str.toLowerCase()
      .replace(/[àâä]/g, 'a')
      .replace(/[éèêë]/g, 'e')
      .replace(/[îï]/g,   'i')
      .replace(/[ôö]/g,   'o')
      .replace(/[ùûü]/g,  'u')
      .replace(/ç/g,      'c')
      .replace(/[^a-z0-9 ]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function translateQuery(raw) {
    var n = norm(raw);
    var result = n;

    for (var i = 0; i < SYNONYMS.length; i++) {
      var fr = SYNONYMS[i][0];
      var en = SYNONYMS[i][1];
      var re = new RegExp('(?:^|\\s)' + fr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?:\\s|$)', 'g');
      if (re.test(result)) {
        result = result.replace(re, function (m) {
          var lead  = m[0] === ' ' ? ' ' : '';
          var trail = m[m.length - 1] === ' ' ? ' ' : '';
          return lead + en + trail;
        }).replace(/\s+/g, ' ').trim();
      }
    }

    return result !== n ? result : raw;
  }

  function hookForm(form) {
    if (form._apexHooked) return;
    form._apexHooked = true;
    form.addEventListener('submit', function () {
      var input = form.querySelector('input[name="q"], input[type="search"]');
      if (input && input.value.trim()) {
        input.value = translateQuery(input.value.trim());
      }
    });
  }

  function hookAll() {
    document.querySelectorAll(
      'form.apex-search__form, form.apex-mob-search-form, form[action="/search"]'
    ).forEach(hookForm);
  }

  hookAll();

  /* Re-hook if Shopify injects forms dynamically */
  var observer = new MutationObserver(function () { hookAll(); });
  observer.observe(document.body, { childList: true, subtree: true });

})();
